export class FileModel {
    fileName = '';
    extension = '';
    encodedBase64 = '';
}
  